<ifc-bar-chart [data]="barChartData"
                    [options]="barChartOptions">
</ifc-bar-chart>
